import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const FinancialDataIconSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="11" y="28" width="7" height="12" rx="1" stroke="currentColor" fill="none" strokeWidth="1.5" />
        <rect x="20.5" y="20" width="7" height="20" rx="1" stroke="currentColor" fill="none" strokeWidth="1.5" />
        <rect x="30" y="12" width="7" height="28" rx="1" stroke="currentColor" fill="none" strokeWidth="1.5" />
    </svg>
)

const FinancialDataIconSvgSmall = (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2.5" y="10.5" width="2.5" height="4.5" rx="0.5" stroke="currentColor" fill="none" strokeWidth="1.25" />
        <rect x="7.25" y="7.5" width="2.5" height="7.5" rx="0.5" stroke="currentColor" fill="none" strokeWidth="1.25" />
        <rect x="12" y="4.5" width="2.5" height="10.5" rx="0.5" stroke="currentColor" fill="none" strokeWidth="1.25" />
    </svg>
)

const FinancialData: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {props.fontSize === 'small' ? FinancialDataIconSvgSmall : FinancialDataIconSvg}
    </SvgIcon>
)

export default FinancialData
